import React, { useCallback, useContext, useMemo } from "react";
import ConfiguratorContext from "../../../context/configurator/ConfiguratorContext";
import Card from "../../UI/Card";
import { Flex } from "reflexbox";
import { Body, Helper } from "../../UI/Text";
import { formatPhoneNumber } from "../../../modules/utilities";
import Loading from "../../UI/Loading";

const AddressHeader = ({ setEditingId, setFormToShow, shippingColor, hideEdit, hideCustomerEdit }) => {
  const config = useContext(ConfiguratorContext);

  const addresses = useMemo(
    () => [config?.quote?.billingAddress, config?.quote?.shippingAddress],
    [config]
  );

  const { companyName } = useMemo(
    () => config?.quote?.customer || {},
    [config]
  );
  const sameAsBilling = useMemo(
    () => !!config?.quote?.sameAsBilling || false,
    [config]
  );
  const { firstName, lastName, email, phone } = useMemo(
    () => config?.quote?.contact || {},
    [config]
  );
  const { Address, Address2, City, State, Zip } = useMemo(
    () => config?.quote?.billingAddress || {},
    [config]
  );
  const onEditContact = useCallback(() => {
    setEditingId(config?.quote?.customer?.id);
    setFormToShow("customer");
  }, [config, setEditingId, setFormToShow]);

  return (
    <Flex
      flexDirection={["column", "column", "row", "row"]}
      my="1rem"
      width={1}
      style={{ gap: "1rem", flexFlow: "wrap" }}
    >
      <Card
        onEdit={onEditContact}
        hideEdit={hideCustomerEdit ? hideCustomerEdit : hideEdit}
        width={
          !sameAsBilling
            ? [1, 1, 1, 1, `calc(${(1 / 3) * 100}% - ${2 / 3}rem)`]
            : [1, 1, 1, 1, `calc(${(2 / 3) * 100}% + 1rem)`]
        }
      >
        <Body bold>{companyName}</Body>
        {/* <Body bold>{`${firstName} ${lastName}`}</Body> */}
        <Body>{email}</Body>
        <Body>{formatPhoneNumber(phone)}</Body>

        <Body>{Address}</Body>
        {!!Address2 && <Body>{Address2}</Body>}
        <Body>{`${City}, ${State} ${Zip}`}</Body>
      </Card>

      {addresses.map((address, i) => {
        const title = i === 0 ? "Billing" : "Shipping";

        const { id, Address, Address2, City, State, Zip, Country } = address || {};

        return sameAsBilling && i === 1 ? null : (
          <Card
            key={id}
            width={[
              1,
              1,
              1,
              `calc(50% - 0.6rem)`,
              `calc(${(1 / 3) * 100}% - ${2 / 3}rem)`,
            ]}           
            onEdit={() => {
              setEditingId(id);
              setFormToShow(title);
            }}
            hideEdit={i === 0 ? true : hideEdit}
            style={{ borderColor: i === 1 ? shippingColor : null }}
          >
            {shippingColor && i === 1 ? (
              <Loading relative />
            ) : (
              <>
                <Helper mb="0.5rem" bold>{`${title} Address:`}</Helper>

                <Body ellipsis>
                  {Address || Address2
                    ? `${Address || ""}${!!Address2 && !!Address ? " " : ""}${
                        Address2 || " "
                      }`
                    : "—"}
                </Body>

                {!!City || !!State || !!Zip ? (
                  <Body>{`${City}, ${State} ${Zip} ${Country}`}</Body>
                ) : null}
              </>
            )}
          </Card>
        );
      })}
    </Flex>
  );
};

export default AddressHeader;
